import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { VueQueryPlugin } from '@tanstack/vue-query'

// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'; // Material Design Icons
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { createI18n } from "vue3-i18n";

// add this
import './index.css'

import { messages } from './internationalization'
import { INITIAL_LANG } from './hook/useLanguage'
import VuePictureSwipe from 'vue3-picture-swipe'

const vuetify = createVuetify({
    components,
    directives,
});

const i18n = createI18n({
    locale: INITIAL_LANG,
    messages: messages,
});

const app = createApp(App)
    .use(router)
    .use(vuetify)
    .use(VueQueryPlugin)
    .use(i18n);
    
app.mount('#app')
